import { useNavigate } from 'react-router-dom'
import { useSelectLatestScreeningType, useSelectScreenings } from '../../../../../state/selectors'
import { SubmitScreeningTemplate } from '../../../../../components/screening/screeningView/SubmitScreeningTemplate'
import { BodyLarge } from '../../../../../components/styles/Typography'
import styled from 'styled-components'
import { theme } from '../../../../../theme/theme'
import { useTranslation } from 'react-i18next'
import { ScreeningType } from '@estercare/ester-shared'

export const SubmitScreening = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const screenings = useSelectScreenings()
  const latestScreeningType = useSelectLatestScreeningType()
  const latestScreening = screenings?.[0]

  if (!latestScreening) return null

  if (latestScreeningType === ScreeningType.FOLLOW_UP || latestScreeningType === ScreeningType.CHECK_IN) {
    return (
      <SubmitScreeningTemplate
        disableButton={latestScreening.completed}
        onCloseSuccessModal={() => navigate('/portal')}
        headerTitle={t('employee.submitScreen.followUpTitle')}
        children={
          <>
            <BodyLarge>{t('employee.submitScreen.followUpInstructions')}</BodyLarge>
            {latestScreeningType === ScreeningType.FOLLOW_UP && (
              <>
                <TextBreak />
                <BodyLarge>{t('employee.submitScreen.followUpProcess')}</BodyLarge>
              </>
            )}
          </>
        }
      />
    )
  }

  return (
    <SubmitScreeningTemplate
      disableButton={latestScreening.completed}
      onCloseSuccessModal={() => {
        navigate('/portal/health-services/screening/book-health-call')
      }}
      headerTitle={t('employee.submitScreen.screeningTitle')}
      successModalTitle={t('employee.submitScreen.screeningSuccessTitle')}
      children={
        <>
          <BodyLarge>{t('employee.submitScreen.screeningInstructions')}</BodyLarge>
          <TextBreak />
          <BodyLarge>{t('employee.submitScreen.screeningProcess')}</BodyLarge>
        </>
      }
    />
  )
}

const TextBreak = styled.div`
  width: 100%;
  height: ${theme.spacing.small}px;
`
